import { ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { TransactionDetails, TransactionHistory } from '@shared/models';
import { selectRouteParams } from '@shared/store';

import { HistoryItemComponent } from '../history-item/history-item.component';

@Component({
  selector: 'app-transaction-history',
  templateUrl: 'transaction-history.component.html',
  styleUrls: ['transaction-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [HistoryItemComponent],
})
export class TransactionHistoryComponent implements OnDestroy {
  @ViewChild('contentElementRef') contentElementRef!: ElementRef<HTMLElement>;

  private store = inject(Store);

  @Input() transactionHistoryItems!: TransactionHistory[];

  @Input() loading = true;

  transactionId!: TransactionDetails['id'];

  private destroy$ = new Subject<void>();

  get firstItemWithSubItems(): string | undefined {
    return this.transactionHistoryItems?.find((item) => item.parentTransactionId)?.id;
  }

  constructor() {
    this.store
      .select(selectRouteParams)
      .pipe(
        takeUntilDestroyed(),
        // router-store 21: selectRouteParams emits undefined until the router state slice is
        // populated (and throughout tests using MockStore), so index defensively.
        map((params) => params?.['transactionId']),
        filter(Boolean),
      )
      .subscribe((transactionId) => {
        this.transactionId = transactionId;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
